// Authentication.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export const loginUser = createAsyncThunk(
  'auth/login',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${apiUrl}/auth/Login/`, credentials,);
      // Store tokens only if no 2FA required
      if (response.data.status && !response.data.data.requires_2fa) {
        localStorage.setItem('accessToken', response.data.data.tokens.access);
        localStorage.setItem('refreshToken', response.data.data.tokens.refresh);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// authSlice.js
export const verifyOTP = createAsyncThunk(
  'auth/verifyOTP',
  async ({ otp_code, username }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${apiUrl}/auth/google-verify/`, {
        otp_code,
        username
      });
      
      if (response.data.status) {
        localStorage.setItem('accessToken', response.data.data.tokens.access);
        localStorage.setItem('refreshToken', response.data.data.tokens.refresh);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  user: null,
  tokens: null,
  requires2FA: false,
  isLoading: false,
  error: null,
  isAuthenticated: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    logout: (state) => {
      state.user = null;
      state.tokens = null;
      state.requires2FA = false;
      state.isAuthenticated = false;
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      // Force a page reload to clear all states
      window.location.href = '/login';
    }
  },
  extraReducers: (builder) => {
    builder
      // Login cases
      .addCase(loginUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.status) {
          if (action.payload.data.requires_2fa) {
            state.requires2FA = true;
          } else {
            state.user = action.payload.data.user;
            state.tokens = action.payload.data.tokens;
            state.isAuthenticated = true;
            state.requires2FA = false;
          }
        }
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || 'Login failed';
      })
      // OTP verification cases
      .addCase(verifyOTP.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(verifyOTP.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.status) {
          state.tokens = action.payload.data.tokens;
          state.isAuthenticated = true;
          state.requires2FA = false;
        }
      })
      .addCase(verifyOTP.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || 'OTP verification failed';
      });
  }
});

export const { clearError, logout } = authSlice.actions;
export default authSlice.reducer;